"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M416.6 41.6H83.3c-23 0-41.7 18.7-41.7 41.7v270.8c0 23 18.7 41.7 41.7 41.7h20.9v52.1c0 9.3 11.2 13.9 17.8 7.4l48.6-59.5h246.1c23 0 41.6-18.6 41.6-41.7V83.3c0-23-18.7-41.7-41.7-41.7zM254.8 327.5c-8.7 0-15.7-7-15.7-15.7s7-15.7 15.7-15.7 15.7 7 15.7 15.7-7.1 15.7-15.7 15.7zm15.6-70.4c0 8.6-7 15.6-15.6 15.6s-15.6-7-15.6-15.6c0-50.7 46.8-46.8 46.8-78.2 0-17.1-14.1-31.2-31.2-31.2s-31.2 14.1-31.2 31.2c0 8.6-7 15.6-15.6 15.6s-15.6-7-15.6-15.6c0-34.5 28-62.5 62.5-62.5s62.5 28 62.5 62.5c-.2 39.1-47 43-47 78.2z"
  });
};

exports.default = _default;